<template>
  <div
    id="app"
    class="app"
  >
    <app-refresh />
    <router-view />
    <app-toaster />
    <app-cookie v-if="$featureFlag('enableCookieConsent')" />
    <portal-target name="app-modal" />
    <vue-up />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { subscribe, unsubscribe } from '@/api'
  import appRefresh from '@/pages/authenticated/app-refresh'
  import appToaster from '@/components/app-toaster'
  import appCookie from '@/components/app-cookie'

  export default {
    name: 'App',
    components: {
      appRefresh,
      appToaster,
      appCookie
    },
    metaInfo () {
      return {
        title: this.$t(`brandnames.${this.brandname}`),
        titleTemplate: '%s'
      }
    },

    data() {
      return {
        displayModal: false
      }
    },

    computed: {
      ...mapGetters({
        isCustomer: 'auth/isCustomer',
        authenticated: 'auth/authenticated'
      }),

      ...mapState({
        brandname: state => state.brandname,
        cguValidated: state => state.auth.user?.cguValidated,
        errorResponse: state => state.error.response,
        user: state => state.auth?.user
      })
    },

    watch: {
      authenticated () {
        this.authChanged()
      },

      errorResponse (response) {
        if (!response) return

        const { status } = response

        if (Math.floor(status / 100) === 5) {
          this.$router.push({name: 'error500'})
        }
      }
    },

    created () {
      this.authChanged()
    },

    mounted () {
      // if (this.$intercom) {
      //   this.$intercom.boot()
      // }
      console.log(`${this.$t(`brandnames.${this.brandname}`)} started with version ${VERSION}`)
    },

    methods: {
      ...mapActions({
        fetchUser: 'auth/fetchUser',
        setLogoutUrl: 'auth/setLogoutUrl'
      }),

      authChanged () {
        if (this.authenticated) {
          subscribe()

          this.fetchUser(false)
            .then(() => {
              if (this.$featureFlag('enableLogoutUrl')) {
                this.setLogoutUrl()
              }

              const routeName = this.$route.name
              if (this.isCustomer && this.cguValidated === false && routeName !== 'cgu' && routeName !== 'cabp-client-auth') {
                this.$router.push({ name: 'cgu' })
              }
            })

        } else {
          unsubscribe()
        }
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/reset';
  @import '~@/styles/common';

  #app {
    overflow-y: hidden
  }

  div.app > .app-toaster {
    padding-top: 8rem;
  }
</style>
